
const Loyalty = {
  LOYALTY_EARN_POINTS_TEXT : "YOU'VE EARNED LOYALTY POINTS!",
  LOYALTY_REDEEM_POINTS_TEXT :
  "Redeem your reward points at any of our brand’s stores near you.",
  LOYALTY_POINTS_LINK_TEXT : "Check your Loyalty Points",
  LOYALTY_TABLE_HEADINGS : [
    "Brands",
    "Points Earned",
    "Loyalty Value",
    "Loyalty Balance",
  ],
  LOYALTY_SUMMARY_TEXT1 : "HERE'S",
  LOYALTY_SUMMARY_TEXT2 : "SUMMARY OF YOUR",
  LOYALTY_POINTS_TEXT : "LOYALTY POINTS",
  LOYALTY_BLOCK_MESSAGES : {
    ERROR_MESSAGE: "Oops! Something went wrong while fetching Loyalty Data.",
  },
  LOYALTY_LINK : "Loyalty"
}

export default Loyalty;
